import { SecondaryWarningAdvisory } from '../SecondaryAdvisory.tsx';

export const ConcurrentMissionsAdvisory = () => {
    return (
        <SecondaryWarningAdvisory header="Concurrent LAANC Missions" advisoryType="advise">
            You already have other mission(s) scheduled that overlap this time period. Please cancel missions that will not be used before their start time.
        </SecondaryWarningAdvisory>
    );
};
